/** Shown in admin when speech audio exists but STT returned no text. */
export const STT_UNRECOGNIZED_LABEL = "Recognition error";

/** Sentinel persisted by worker / control-api. */
export const STT_UNRECOGNIZED_PLACEHOLDER = "[unrecognized]";

export function isSttUnrecognized(
  text: string | undefined | null,
  unrecognized?: boolean,
): boolean {
  if (unrecognized) return true;
  const t = String(text || "").trim();
  return t === STT_UNRECOGNIZED_PLACEHOLDER || t === STT_UNRECOGNIZED_LABEL;
}

export function sttUnrecognizedDisplayText(
  text: string | undefined | null,
  unrecognized?: boolean,
): string {
  if (isSttUnrecognized(text, unrecognized)) return STT_UNRECOGNIZED_LABEL;
  return String(text || "").trim();
}
